import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../../assets/logo.png';

const Navbar = () => {
  const token = localStorage.getItem('token');
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/';
  };

  return (
    <nav className="navbar">
      <div className="container">
        <Link to="/" className="logo">
          <img src={logo} alt="HealthGuardian" className="logo-image" />
        </Link>
        <div className="links">
          <Link to="/" className={`link ${location.pathname === '/' ? 'active' : ''}`}>
            Accueil
          </Link>
          {token ? (
            <>
              <Link to="/dashboard" className={`link ${location.pathname === '/dashboard' ? 'active' : ''}`}>
                Tableau de bord
              </Link>
              <Link to="/analyse" className={`link ${location.pathname === '/analyse' ? 'active' : ''}`}>
                Analyse
              </Link>
              <button 
                onClick={handleLogout} 
                className="link"
              >
                Déconnexion
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className={`link ${location.pathname === '/login' ? 'active' : ''}`}>
                Connexion
              </Link>
              <Link to="/register" className={`link ${location.pathname === '/register' ? 'active' : ''}`}>
                Inscription
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 